import { render, staticRenderFns } from "./DataProcessView.vue?vue&type=template&id=515d3346&scoped=true"
import script from "./DataProcessView.vue?vue&type=script&lang=js"
export * from "./DataProcessView.vue?vue&type=script&lang=js"
import style0 from "./DataProcessView.vue?vue&type=style&index=0&id=515d3346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515d3346",
  null
  
)

export default component.exports